module.exports = __webpack_public_path__ + "static/img/spoon.6bed68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/spoon.png
// module id = 6Pb+
// module chunks = 0